import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import {
  Button,
  Dialog,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  DialogTitle,
  TextField,
} from "@mui/material";
import axios from "axios";
import EditSportGuard from "./editSportGuard";
import DeleteModal from "./deletemodal";

const SpotGurd = () => {
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [pricingColumns, setPricingColumns] = useState([]);
  const [, setMaxPricings] = useState(0);
  const [specialPricingColumns, setSpecialPricingColumns] = useState([]);
  const [, setMaxSpecialPricings] = useState(0);
  const [price, setPrice] = useState("");
  const [element, setElement] = useState("");
  const [trace, setTrace] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  //  const [specialPricing, setSpecialPricing] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({
    name: "",
    priceper: "",
    isLotRequired: false,
    allowNoteForLot: false,
    isSerialRequired: false,
    allowNoteForSerial: false,
  });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prevState => ({
  //     ...prevState,
  //     [name]: value
  //   }));
  // };
  const [,] = useState({
    procedureFrom: "",
    designMode: "",
    materialClass: "",
    procedureTo: "",
  });
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState({});

  const onRowsUpdate = (newRows) => {
    setRows(newRows);
  };

  useEffect(() => {
    const fetchSportgurds = async () => {
      try {
        const response = await axios.get(
          "https://hms.backend.hiragroupcloud.com/api/spot-gurds"
        );

        const data = response.data;

        const maxPricing = Math.max(
          ...data?.data?.map((item) => item?.spotGurdPricing?.length)
        );
        setMaxPricings(maxPricing);

        const pricingColumns = [];
        for (let i = 0; i < maxPricing; i++) {
          pricingColumns.push({
            field: `amount_${i + 1}`,
            headerName: `Default price`,
            width: 150,
            align: "center",
            headerAlign: "center",
          });
          pricingColumns.push({
            field: `pricePer_${i + 1}`,
            headerName: `Price Per`,
            width: 150,
            align: "center",
            headerAlign: "center",
          });
        }
        setPricingColumns(pricingColumns);

        const maxSpecialPricing = Math.max(
          ...data.data.map((item) => item?.spotGurdSpecialPrice?.length)
        );
        setMaxSpecialPricings(maxSpecialPricing);

        const specialPricingColumns = [];
        for (let i = 0; i < maxSpecialPricing; i++) {
          specialPricingColumns.push({
            field: `pricingFor_${i + 1}`,
            headerName: `Pricing per`,
            width: 150,
            align: "center",
            headerAlign: "center",
          });
        }
        setSpecialPricingColumns(specialPricingColumns);
        const transformedRows = data?.data?.map((item) => {
          const pricingFields = {};
          item?.spotGurdPricing?.forEach((pric, index) => {
            pricingFields[`amount_${index + 1}`] = pric?.amount || "";
            pricingFields[`pricePer_${index + 1}`] = pric?.pricePer || "";
          });

          const specialPricingFields = {};
          item?.spotGurdSpecialPrice?.forEach((pricfor, index) => {
            specialPricingFields[`pricingFor_${index + 1}`] =
              pricfor?.pricingFor || "";
          });

          // Construct the final row object
          return {
            _id: item._id,
            valueName: item.valueName,
            allowNoteForLot: item.allowNoteForLot || false,
            isLotRequired: item.isLotRequired || false,
            isSerialRequired: item.isSerialRequired || false,
            allowNoteForSerial: item.allowNoteForSerial || false,
            ...pricingFields,
            ...specialPricingFields,
            pricing: item?.spotGurdPricing || [],
            specialPricing: item?.spotGurdSpecialPrice || [],
          };
        });

        setRows(transformedRows);
      } catch (error) {
        console.error("Failed to fetch sport guards colors:", error);
      }
    };

    fetchSportgurds();
  }, []);

  // const handleEdit = (id) => {
  //   const rowData = rows.find(row => row._id === id);
  //   setEditData(rowData);

  //   if (rowData.pricing && rowData.pricing.length > 0) {
  //     setSelectedRowData({
  //       ...rowData,
  //       taxable: rowData.pricing[0].taxable || '',
  //     });
  //   } else {
  //     setSelectedRowData(rowData);
  //   }
  //   setOpen(true);
  // };

  const handleEdit = async (id) => {
    setShowEditModal(true);
    const selectedRow = rows.filter((row) => row._id === id);
    setSelectedRowData(selectedRow);
  };

  const handleDelete = (id) => {
    setShowDeleteModal(true);
    setRows(rows.filter((row) => row._id !== id));
    // setSelectedRowId(null);
  };

  const handleRowClick = (row) => {
    const { _id } = row;
    setSelectedRowId(_id === selectedRowId ? null : _id);
  };

  const handleModalClose = () => {
    setOpen(false);
    setEditData({});
  };

  const handleSave = async () => {
    try {
      const response = await fetch(
        `https://hms.backend.hiragroupcloud.com/api/spot-gurds/${editData._id}`,
        {
          // Updated endpoint for saving
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(editData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update data");
      }

      const updatedRow = await response.json();

      setRows(
        rows.map((row) =>
          row._id === updatedRow.data._id ? updatedRow.data : row
        )
      );

      handleModalClose();
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const filteredRows = rows.filter((row) =>
    Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const baseColumns = [
    { field: "valueName", headerName: "Name", width: 150 },
    // { field: 'amount', headerName: 'Default Price', width: 200, align: 'center', headerAlign: 'center' },
    // { field: 'pricePer', headerName: 'Price Per', width: 150, align: 'center', headerAlign: 'center' },
  ];

  const allColumns = [
    ...baseColumns,
    ...pricingColumns.filter((column) =>
      column.field ? column.field in rows[0] : ""
    ),
    ...specialPricingColumns.filter((column) =>
      column.field ? column.field in rows[0] : ""
    ),
  ];
  return (
    <>
      <h1 className="title"> Sport Guard Colors</h1>
      <div style={{backgroundColor:'#f4f4f4',padding:"10px",width:'1560px',margin:'0 auto'}}>
      <div className="search">
        <div className="row align-items-center">
      
            <div className="col-md-6 d-flex justify-content-start">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
         
          <div className="col-md-6 d-flex justify-content-end">
            <Link
              to="/AddSportGuardColor"
              className="btn btn-primary"
              style={{ backgroundColor: "#004aad", borderColor: "#004aad" }}
            >
              Add
            </Link>
          </div>
        </div>
      </div>

      <div
        style={{
          height: 350,
          width: "100%",
          position: "relative",
          marginTop: "2%",
          background: "#f0f0f5",
        }}
      >
        <DataGrid
          rows={filteredRows}
          columns={allColumns}
          pageSize={5}
          onRowClick={(params) => handleRowClick(params.row)}
          getRowId={(row) => row._id}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
          }}
        />
        {selectedRowId !== null && (
          <div
            style={{
              position: "absolute",
              top: rows.findIndex((row) => row._id === selectedRowId) * 52 + 48,
              right: "10px",
              display: "flex",
              marginTop: "15px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleEdit(selectedRowId)}
              sx={{ marginRight: 1 }}
            >
              Edit
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "red",
                "&:hover": { backgroundColor: "#c62828" },
              }}
              onClick={() => handleDelete(selectedRowId)}
            >
              Delete
            </Button>
          </div>
        )}
      </div>
      </div>
      <EditSportGuard
        showEditModal={showEditModal}
        handleEditClose={() => setShowEditModal(false)}
        selectedRowData={selectedRowData}
        editRows={rows}
        onRowsUpdate={onRowsUpdate}
      />

      <DeleteModal
        showDeleteModal={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        selectedRowId={selectedRowId}
      />

      {/* Modal for Editing */}
      <Dialog open={open} onClose={handleModalClose}>
        <DialogTitle>Edit Sport Guards</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            variant="outlined"
            value={editData.valueName || ""}
            onChange={(e) =>
              setEditData({ ...editData, valueName: e.target.value })
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedRowData?.isLotRequired === true}
                onChange={(e) =>
                  setSelectedRowData((prevData) => ({
                    ...prevData,
                    isLotRequired: e.target.checked ? true : false,
                  }))
                }
                color="primary"
              />
            }
            label="Lot Required"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedRowData?.allowNoteForLot === true}
                onChange={(e) =>
                  setSelectedRowData((prevData) => ({
                    ...prevData,
                    allowNoteForLot: e.target.checked ? true : false,
                  }))
                }
                color="primary"
              />
            }
            label="Allow Note for Lot"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedRowData?.isSerialRequired === true}
                onChange={(e) =>
                  setSelectedRowData((prevData) => ({
                    ...prevData,
                    isSerialRequired: e.target.checked ? true : false,
                  }))
                }
                color="primary"
              />
            }
            label="Serial Required"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedRowData?.allowNoteForSerial === true}
                onChange={(e) =>
                  setSelectedRowData((prevData) => ({
                    ...prevData,
                    allowNoteForSerial: e.target.checked ? true : false,
                  }))
                }
                color="primary"
              />
            }
            label="Allow Note for Serial"
          />
          {/* <TextField
            margin="dense"
            label="Classification"
            type="text"
            fullWidth
            variant="outlined"
            value={editData.classification || ''}
            onChange={(e) => setEditData({ ...editData, })}
          /> */}

          {pricingColumns.map((column) => (
            <TextField
              key={column.field}
              margin="dense"
              label={column.headerName}
              type="text"
              fullWidth
              variant="outlined"
              value={editData[column.field] || ""}
              onChange={(e) =>
                setEditData({ ...editData, [column.field]: e.target.value })
              }
            />
          ))}
          <TextField
            autoFocus
            margin="dense"
            label="Taxable"
            name="Taxable"
            fullWidth
            value={selectedRowData.taxable || ""}
            onChange={(e) =>
              setSelectedRowData({
                ...selectedRowData,
                taxable: e.target.value,
              })
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  selectedRowData?.Neverrolluppriceintoprocedure === true
                }
                onChange={(e) =>
                  setSelectedRowData((prevData) => ({
                    ...prevData,
                    Neverrolluppriceintoprocedure: e.target.checked
                      ? true
                      : false,
                  }))
                }
                color="primary"
              />
            }
            label="Never roll-up price into procedure"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  selectedRowData?.Suppressthisattributevaluewhenpriceiszero ===
                  true
                }
                onChange={(e) =>
                  setSelectedRowData((prevData) => ({
                    ...prevData,
                    Suppressthisattributevaluewhenpriceiszero: e.target.checked
                      ? true
                      : false,
                  }))
                }
                color="primary"
              />
            }
            label="Suppress this attribute value when price is zero"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  selectedRowData?.Suppressthisattributeonreports === true
                }
                onChange={(e) =>
                  setSelectedRowData((prevData) => ({
                    ...prevData,
                    Suppressthisattributeonreports: e.target.checked
                      ? true
                      : false,
                  }))
                }
                color="primary"
              />
            }
            label="Suppress this attribute on reports"
          />
          {specialPricingColumns.map((column) => (
            <TextField
              key={column.field}
              margin="dense"
              label={column.headerName}
              type="text"
              fullWidth
              variant="outlined"
              value={editData[column.field] || ""}
              onChange={(e) =>
                setEditData({ ...editData, [column.field]: e.target.value })
              }
            />
          ))}
          <TextField
            margin="dense"
            label="Price"
            type="number"
            fullWidth
            variant="outlined"
            value={price || ""}
            onChange={(e) => setPrice(e.target.value)}
            inputProps={{ min: 0, step: "0.01" }}
          />
          <TextField
            margin="dense"
            label="Element"
            type="text"
            fullWidth
            variant="outlined"
            value={element || ""}
            onChange={(e) => setElement(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Trace"
            type="text"
            fullWidth
            variant="outlined"
            value={trace || ""}
            onChange={(e) => setTrace(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose}>Cancel</Button>
          <Button onClick={handleSave}>Save Change</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SpotGurd;
